import { AUFTRAG_API } from '@Constants/backendConstants';
import { isOk, type Result, useSynqoHttp } from '@synqo/frontend-component-library';
import { useCallback, useState } from 'react';
import type { CancelStorageTransactionCommand, StorageTransactionCancellationView } from './cancelCommand';

const NOT_CANCELLED = 'Die Buchung konnte nicht storniert werden.';

export interface StorageTransactionCancelling {
    /** Resolves to whether the booking was cancelled. */
    cancel: (reason: string) => Promise<boolean>;
    pending: boolean;
    /** Why the last attempt failed, empty while it did not. */
    errors: string[];
}

/** Sends the cancellation of a booking and keeps what the server answered with. */
// @ai-generated 2026-10-26T16:30:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function useCancelStorageTransaction(bookingId: string): StorageTransactionCancelling {
    const http = useSynqoHttp(AUFTRAG_API);
    const [pending, setPending] = useState(false);
    const [errors, setErrors] = useState<string[]>([]);

    const cancel = useCallback(
        async (reason: string) => {
            setPending(true);
            setErrors([]);
            const result = await http.post<Result<StorageTransactionCancellationView>, CancelStorageTransactionCommand>(
                '/storage_transactions:cancel.v1',
                { storage_transaction_id: bookingId, reason },
            );
            setPending(false);

            if (!isOk(result)) {
                const texts = (result.messages ?? []).map((message) => message.message).filter(Boolean);
                setErrors(texts.length > 0 ? texts : [NOT_CANCELLED]);
                return false;
            }

            return true;
        },
        [http, bookingId],
    );

    return { cancel, pending, errors };
}
